export default  {	
	data () {
		return { 
			cardCol: 9,
			cardCol2: 3,
			cardHover: 1,
			editarDataPost: false,
			total: 0,
			active: 0,
			updates: 0,
			ultimaRazon: null,
			errorsAportes: null,
			datosAsesor: null,
			cargueCreated: false
		}
	},
	async created () { 
		await this.onInit()
	},
	methods:{
		async onInit()
		{

			this.ultimaRazon=this.dataForm[this.namePath].info_afiliacion.id_datos_razon
			const await0 = this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
			const await1 = this.updateDataForm({state: 'info_afiliacion/mes_periodo', data: this.fecha().fecha.mesHoy})
			const await2 = this.updateDataForm({state: 'info_afiliacion/ano_periodo', data: this.fecha().fecha.anoHoy})
			const await3 = this.updateDataForm({state: 'afiliado_beneficiarios', data: []})
			const await4 = this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })	

			await Promise.all([await0,await1,await2,await3,await4])
			this.cargueCreated=true
			
		}
	}
}
